import type { ItemImage } from "@/lib/types";

export function isEditListingImagePendingDelete(image: ItemImage): boolean {
  return image.metadata?.__pendingDelete === true;
}

export function isEditListingTempImage(image: ItemImage): boolean {
  return image.id.startsWith("temp-");
}

/**
 * Delete policy for preview/edit drafts:
 * - Local-only (`temp-…`) → hard remove immediately
 * - Persisted DB images → mark-for-delete until save
 */
export function shouldHardDeleteListingImage(image: ItemImage): boolean {
  return isEditListingTempImage(image);
}

export function getActiveEditListingImages(images: ItemImage[]): ItemImage[] {
  return images.filter((img) => !isEditListingImagePendingDelete(img));
}

/**
 * True when the seller changed photos (add/remove/replace/main) vs page-load baseline.
 */
export function editListingImagesHaveChanges(
  images: ItemImage[],
  baselineImages: ItemImage[],
): boolean {
  const active = getActiveEditListingImages(images);
  if (active.some(isEditListingTempImage)) return true;
  if (images.some(isEditListingImagePendingDelete)) return true;

  const baselineIds = baselineImages.map((img) => img.id).sort();
  const activeIds = active.map((img) => img.id).sort();
  if (baselineIds.length !== activeIds.length) return true;
  if (baselineIds.some((id, i) => id !== activeIds[i])) return true;

  const baselineMain = baselineImages.find((img) => img.isMain)?.id ?? null;
  const activeMain = active.find((img) => img.isMain)?.id ?? null;
  return baselineMain !== activeMain;
}
